import React from 'react';
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';


const SalonThemeDecisionDialog = ({
  open,
  title,
  description,
  cancelLabel,
  confirmLabel,
  loading = false,
  direction = 'ltr',
  onCancel,
  onConfirm,
  onExited,
}) => (
  <Dialog
    open={open}
    onClose={() => {
      if (!loading) onCancel();
    }}
    aria-labelledby="salon-theme-decision-title"
    aria-describedby="salon-theme-decision-description"
    maxWidth="xs"
    fullWidth
    PaperProps={{ dir: direction }}
    TransitionProps={{ onExited }}
  >
    <DialogTitle id="salon-theme-decision-title">{title}</DialogTitle>
    <DialogContent>
      <DialogContentText id="salon-theme-decision-description">
        {description}
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button
        autoFocus
        onClick={onCancel}
        disabled={loading}
        sx={{ minHeight: 44 }}
      >
        {cancelLabel}
      </Button>
      <Button
        variant="contained"
        color="error"
        onClick={onConfirm}
        disabled={loading}
        sx={{ minHeight: 44 }}
        startIcon={loading ? (
          <CircularProgress size={18} color="inherit" />
        ) : null}
      >
        {confirmLabel}
      </Button>
    </DialogActions>
  </Dialog>
);

export default SalonThemeDecisionDialog;
